import { createFileRoute, useParams } from '@tanstack/react-router';

import { WikiSurface } from '@/widgets/wiki/wiki-surface';

function TeamDocsPage() {
  const { teamSlug } = useParams({ from: '/teams/$teamSlug/docs' });
  return <WikiSurface scope={{ teamSlug }} />;
}

export const Route = createFileRoute('/teams/$teamSlug/docs')({ component: TeamDocsPage });
